// extracted by mini-css-extract-plugin
export default {"wrapper":"impressions-aggregate_wrapper__Hj79q","content":"impressions-aggregate_content__jr7WK"};